import _get from 'lodash/get';
import _template from 'lodash/template';

// TODO: add pluralization
// https://kazupon.github.io/vue-i18n/guide/pluralization.html#pluralization

const INTERPOLATE_REGEXP = /{([\s\S]+?)}/g;
const cache = {};

function interpolate(message, values) {
  if (!values) {
    return message;
  }

  let compiled = cache[message];

  if (!compiled) {
    compiled = _template(message, { interpolate: INTERPOLATE_REGEXP });
    cache[message] = compiled;
  }

  return compiled(values);
}

export default function translate(messages, path, values, defaultValue) {
  const message = _get(messages, path, defaultValue || path);
  return interpolate(message, values);
}
